function decodeBase64Url(value: string): string {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
  return atob(padded);
}

export function parsePermissionsFromToken(token: string | null): Set<string> {
  if (!token) {
    return new Set();
  }

  const parts = token.split('.');
  if (parts.length < 2) {
    return new Set();
  }

  try {
    const payload = JSON.parse(decodeBase64Url(parts[1])) as {
      permissions?: string;
    };

    if (!payload.permissions) {
      return new Set();
    }

    const permissions = JSON.parse(payload.permissions) as string[];

    if (!Array.isArray(permissions)) {
      return new Set();
    }

    return new Set(permissions.filter((p) => typeof p === 'string'));
  } catch {
    return new Set();
  }
}
